import React, { useState, useEffect, useContext } from "react";
import { LoadingPanel } from "../LoadingPanel/LoadingPanel";
import { sendLoadingPostRequest } from "../../request/request";
import FormContext from "../../contexts/FormContext";
import "react-phone-input-2/lib/material.css";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { ILeadsResponse } from "../../types/ILeadsResponse";
import ID from "../../assets/weryfikacja_1.svg";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  styled,
} from "@mui/material";
import "./Step0Form.css";

interface IAgreementDetailsParams {
  leads?: string;
}

interface IStep0Form {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const TextField = styled("input")({
  width: "100%",
  height: 50,
});

const Step0Form = ({ step, setStep }: IStep0Form) => {
  const context = useContext(FormContext);
  const [params, setParams] = useState<IAgreementDetailsParams>();
  const [loading, setLoading] = useState<boolean>(false);
  const [ready, setReady] = useState<boolean>(true);
  const [open, setOpen] = useState<boolean>(false);

  const location = useLocation();

  useEffect(() => {
    const params = queryString.parse(
      location.search
    ) as IAgreementDetailsParams;
    setParams(params);
    if (params.leads) {
      setMarkLead(params.leads);
      getLeadsData(params.leads);
    }

    const cookie = getCookie("office_365_processing_data_accept");
    if (cookie === "yes") setOpen(false);
    else setOpen(true);
  }, []);

  const getCookie = (name: string) => {
    let cookie: any = {};
    document.cookie.split(";").forEach(function (el) {
      let [k, v] = el.split("=");
      cookie[k.trim()] = v;
    });
    return cookie[name];
  };

  const setMarkLead = async (guid: string) => {
    await sendLoadingPostRequest({
      loadingFunction: setLoading,
      endpoint: "Leads/MarkLinkAsUsed",
      params: {
        guid,
      },
    });
  };

  const checkAgreementByLead = async (guid: string) => {
    const { success, data } = await sendLoadingPostRequest<
      IAgreementDetailsParams,
      boolean
    >({
      loadingFunction: setLoading,
      endpoint: "Agreement/CheckIsExistsByLeadsGuid",
      params: {
        leads: guid,
      },
    });
    if (success) {
      if (data && !data.data) {
        return false;
      }
    }
    return true;
  };

  const getLeadsData = async (guid: string) => {
    if (await checkAgreementByLead(guid)) {
      setStep(-1);
    }

    const { success, data } = await sendLoadingPostRequest<any, ILeadsResponse>(
      {
        loadingFunction: setLoading,
        endpoint: "Leads/GetLeadByGuid",
        params: {
          guid,
        },
      }
    );
    setReady(false);
    if (success) {
      if (data?.data) {
        if (context.setLeads) {
          context.setLeads({
            data: data?.data,
            guid,
          });
        }
        if (context.setStep1) {
          context.setStep1({
            firstName: data?.data?.firstName ?? "",
            lastName: data?.data?.lastName ?? "",
            phone: data?.data?.phone ?? "",
            mail: data?.data?.email ?? "",
            dataProcessing: false,
            dataConfirm: false,
            confirmEmailCode: "",
          });
        }
      } else {
        setStep(-1);
      }
    }
    setReady(true);
  };

  return (
    <>
      <Dialog open={open}>
        <DialogTitle>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            Informacja dot. przetwarzania danych
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Informujemy, że korzystamy z aplikacji pakietu Microsoft 365
            dostarczanych przez Microsoft, opartych o technologię chmury
            obliczeniowej. Wpływa to na sposób, w jaki przetwarzamy Państwa dane
            osobowe. Aktualne informacje dotyczące przetwarzania Państwa danych
            osobowych przez DI Xelion znajdują się pod adresem{" "}
            <a
              href="https://www.xelion.pl/informacje-ado"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.xelion.pl/informacje-ado
            </a>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              const isLocalhost =
                window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1";
              let domain = "";
              if (!isLocalhost) {
                domain = ";domain=xelion.pl";
              }

              const exdate = new Date();
              exdate.setDate(exdate.getDate() + 3650);
              document.cookie =
                "office_365_processing_data_accept=yes;path=/;expires=" +
                exdate.toUTCString() +
                domain;
              setOpen(false);
            }}
          >
            Rozumiem
          </Button>
        </DialogActions>
      </Dialog>
      <p className="header2">
        Zostań naszym Klientem{" "}
        <span className="red bold">bez wychodzenia z domu!</span>
      </p>
      <p className="mt-4">
        <span className="red bold">Wypełnienie</span> tego wniosku zajmie Ci{" "}
        <span className="red bold">około 5 minut.</span>
      </p>
      <div className="cardsContainer" style={{ marginTop: '25px' }}>
        <div className="cardDocument marginRight">
          <div className="cardImage">
            <img src={ID} width="70" alt="" />
          </div>
          <span style={{ marginLeft: '10px' }}>
            W trakcie poprosimy Cię o potwierdzenie swojej tożsamości za pośrednictwem
            <span className="red bold ml-1">
              aplikacji mObywatel.
            </span>
          </span>

        </div>
      </div>
      <p style={{ marginTop: '25px' }}>
        Zanim przejdziesz do kolejnych kroków,
        <span className="red bold ml-1">
          przygotuj skan lub zdjęcie dowodu osobistego
        </span>
      </p>
      <p className="containerMargin">
        Ze względów bezpieczeństwa załączone dokumenty zostaną zaszyfrowane
        kodem, który wyślemy na podany przez Ciebie, w kolejnych krokach
        wniosku, numer telefonu komórkowego.
      </p>
      <p>
        Na końcu otrzymasz
        <span className="red bold ml-1">
          potwierdzenie nadania dostępu do Platformy Xelion.
        </span>
      </p>
      <Button
        variant="contained"
        color="primary"
        className="startButton mt-4 float-right mb-2"
        onClick={() => setStep(1)}
      >
        Zaczynamy
      </Button>

      {(loading || !ready) && <LoadingPanel />}
    </>
  );
};

export { Step0Form };
